module.exports = __webpack_public_path__ + "img/3.ebb93acf.jpg";